<div class="rp-page">

  <header class="rp-header">
    <a class="rp-logo" href="/">
      <span class="logo-pxl">pxl</span><span class="logo-vd">vd</span><span class="logo-dot">.com</span>
    </a>
  </header>

  <div class="rp-wrap">
    <div class="rp-card">

      <!-- ── Waiting for Supabase to process the hash ── -->
      <ng-container *ngIf="view === 'waiting'">
        <div class="rp-icon loading">⏳</div>
        <h1 class="rp-title loading">Verifying link…</h1>
        <p class="rp-subtitle">Just a moment.</p>
      </ng-container>

      <!-- ── New password form ── -->
      <ng-container *ngIf="view === 'form'">
        <div class="rp-icon success">🔑</div>
        <h1 class="rp-title">Set new password</h1>
        <p class="rp-subtitle">Choose a new password for your pxlvd account.</p>

        <div class="rp-error" *ngIf="errorMsg">{{ errorMsg }}</div>

        <div class="rp-field">
          <label class="rp-label">New password</label>
          <input class="rp-input" type="password" [(ngModel)]="password"
                 placeholder="Min. 8 characters" autocomplete="new-password" autofocus>
        </div>
        <div class="rp-field">
          <label class="rp-label">Confirm password</label>
          <input class="rp-input" type="password" [(ngModel)]="confirmPassword"
                 placeholder="••••••••" autocomplete="new-password"
                 (keydown.enter)="onSubmit()">
        </div>

        <button class="rp-btn-primary" (click)="onSubmit()" [disabled]="loading">
          <span *ngIf="!loading">Update password</span>
          <span *ngIf="loading" class="rp-spinner"></span>
        </button>
      </ng-container>

      <!-- ── Success ── -->
      <ng-container *ngIf="view === 'success'">
        <div class="rp-icon success">✓</div>
        <h1 class="rp-title">Password updated</h1>
        <p class="rp-subtitle">Your password has been changed. You're still signed in.</p>
        <button class="rp-btn-primary" (click)="goToApp()">Open Studio →</button>
      </ng-container>

      <!-- ── Invalid / expired link ── -->
      <ng-container *ngIf="view === 'invalid'">
        <div class="rp-icon error">✕</div>
        <h1 class="rp-title error">Link expired or invalid</h1>
        <p class="rp-subtitle">
          This reset link has expired or has already been used.
          Request a new one from the sign-in screen.
        </p>
        <button class="rp-btn-primary" (click)="goToLogin()">Back to sign in</button>
      </ng-container>

      <!-- ── OAuth-only account ── -->
      <ng-container *ngIf="view === 'oauth-only'">
        <div class="rp-icon oauth">🔒</div>
        <h1 class="rp-title">No password on this account</h1>
        <p class="rp-subtitle">
          Your pxlvd account is linked to <strong>{{ oauthProvider }}</strong> -
          there's no password to reset. Sign in using the
          <strong>Continue with {{ oauthProvider }}</strong> button instead.
        </p>
        <button class="rp-btn-primary" (click)="goToLogin()">Back to sign in</button>
      </ng-container>

    </div>
  </div>

  <footer class="rp-footer">
    <span>© 2026 pxlvd. Made in Perth, Western Australia.</span>
    <div class="rp-footer-links">
      <a href="/home/privacy-policy">Privacy</a>
      <a href="/home/terms">Terms</a>
      <a href="mailto:manoj@pxlvd.com">Contact</a>
    </div>
  </footer>

</div>
